import React from 'react';
import { PopoverProps } from 'antd';

import {
  StyledAntdPopover,
} from './style';

const CVPopover = (props: PopoverProps): JSX.Element => (
  <StyledAntdPopover {...props} />
);

export default CVPopover;
